import { useState, useEffect, useCallback } from 'react';
import { api } from '../api';

/**
 * Hook to fetch and check current user's permissions.
 * Super admins bypass all permission checks.
 *
 * Usage:
 *   const { hasPermission, loading } = usePermissions();
 *   if (hasPermission('v1-ivf-update-procedure')) { ... }
 */
export function usePermissions() {
  const [permissions, setPermissions] = useState([]);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Read is_super_admin from localStorage (set at login)
    try {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      if (userData?.is_super_admin === true) {
        setIsSuperAdmin(true);
        setLoading(false);
        return;
      }
    } catch {
      // ignore parse errors
    }

    // Fetch user ACL from auth service
    api.auth.getMyPermissions()
      .then((res) => {
        const keys = res?.data?.permissions?.map((p) => p.permission_key || p.key || p) ?? [];
        setPermissions(keys);
      })
      .catch(() => {
        setPermissions([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const hasPermission = useCallback(
    (key) => {
      if (isSuperAdmin) return true;
      return permissions.includes(key);
    },
    [isSuperAdmin, permissions],
  );

  return { hasPermission, permissions, isSuperAdmin, loading };
}
